/* TF Trust v8 ships-today countdown (Tires Fast). Loaded by blocks/tf-trust.liquid */
(function () {
  if (window.tfTrustLoaded) return;
  window.tfTrustLoaded = true;

  function init(root) {
    if (!root || root.dataset.tfInit === '1') return;
    root.dataset.tfInit = '1';
    var cutoffHour = parseInt(root.dataset.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 14;
    var cutoffMinute = parseInt(root.dataset.cutoffMinute, 10) || 0;
    var timezone = root.dataset.timezone || 'America/New_York';
    var businessDays = (root.dataset.businessDays || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
    var labelEl = root.querySelector('[data-tf-shipping]');
    var dotEl = root.querySelector('.tf-trust__dot');
    if (!labelEl) return;

    function merchantNow() {
      var now = new Date();
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: timezone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false }).formatToParts(now);
        var o = {};
        for (var i = 0; i < parts.length; i++) { if (parts[i].type !== 'literal') o[parts[i].type] = parseInt(parts[i].value, 10); }
        if (o.hour === 24) o.hour = 0;
        return new Date(o.year, o.month - 1, o.day, o.hour, o.minute, o.second);
      } catch (e) { return now; }
    }
    function isBusinessDay(d) { return businessDays.indexOf(d.getDay()) !== -1; }
    function nextBusinessDay(from) {
      var d = new Date(from);
      for (var i = 0; i < 8; i++) {
        d.setDate(d.getDate() + 1);
        if (isBusinessDay(d)) return d;
      }
      return d;
    }
    function nextBusinessDayName(from) {
      var d = nextBusinessDay(from);
      var tomorrow = new Date(from);
      tomorrow.setDate(tomorrow.getDate() + 1);
      var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      return d.toDateString() === tomorrow.toDateString() ? 'tomorrow' : names[d.getDay()];
    }
    function render() {
      var now = merchantNow();
      var cutoff = new Date(now);
      cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);
      if (isBusinessDay(now) && now < cutoff) {
        var ms = cutoff - now;
        var h = Math.floor(ms / 3600000);
        var m = Math.floor((ms % 3600000) / 60000);
        labelEl.innerHTML = '<strong>Ships today</strong>&nbsp;&nbsp;<span class=tf-trust__countdown>' + (h > 0 ? h + 'h ' : '') + m + 'm</span> left';
        if (dotEl) dotEl.classList.add('tf-trust__dot--pulse');
      } else {
        labelEl.innerHTML = '<strong>Ships ' + nextBusinessDayName(now) + '</strong>';
        if (dotEl) dotEl.classList.remove('tf-trust__dot--pulse');
      }
    }
    render();
    setInterval(render, 60000);

  }

  function initAll() {
    var blocks = document.querySelectorAll('[data-tf-trust-block]');
    for (var i = 0; i < blocks.length; i++) init(blocks[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', initAll);
})();